import React, { useRef } from "react";
// import { FilePdfIcon } from "../../assets/icons/FilePdfIcon";
// import { FileTxtIcon } from "../../assets/icons/FileTxtIcon";
// import { FileSpreadsheetIcon } from "../../assets/icons/FileSpreadsheetIcon";
// import { FileCodeIcon } from "../../assets/icons/FileCodeIcon";
// import { FileCsvIcon } from "../../assets/icons/FileCsvIcon";
// import { FilePresentationIcon } from "../../assets/icons/FilePresentationIcon";
// import FileWordIcon from "../../assets/icons/FileWordIcon";
// import { FileIcon } from "../../assets/icons/FileIcon";
import { TrashIcon } from "../../assets/icons/TrashIcon";
// import { GoogleDriveIcon } from "../../assets/icons/GoogleDriveIcon";

// Стили с использованием CSS модулей
import styles from "./FileCard.module.scss";

export default function FileCard({ name, size, onDelete }) {
  const cardRef = useRef(null);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Байт";

    const k = 1000;
    const sizes = ["Байт", "КБ", "МБ", "ГБ", "ТБ", "ПБ", "ЭБ", "ЗБ", "ЙБ"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i)) + " " + sizes[i];
  };

  const getCurrentDate = () => {
    const now = new Date();
    return `${String(now.getDate()).padStart(2, "0")}.${String(
      now.getMonth() + 1
    ).padStart(2, "0")}.${now.getFullYear()}`;
  };

  const handleMouseEnter = () => {
    const card = cardRef.current;
    const index = Array.from(card.parentNode.children).indexOf(card);

    if ((index + 1) % 2 !== 0) {
      const prevCard = card.previousElementSibling;
      if (prevCard?.classList.contains(styles.fileCard)) {
        prevCard.style.borderBottomColor = "transparent";
      }
    }
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    const index = Array.from(card.parentNode.children).indexOf(card);

    if ((index + 1) % 2 !== 0) {
      const prevCard = card.previousElementSibling;
      if (prevCard?.classList.contains(styles.fileCard)) {
        prevCard.style.borderBottomColor = ""; // сброс
      }
    }
  };

  return (
    <div
      className={styles.fileCard}
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={styles.fileInfo}>
        <div className={styles.fileLeft}>
          <label className={styles.fileName}>{name}</label>
          <span className={styles.fileDate}>{getCurrentDate()}</span>
        </div>
        <div className={styles.fileRight}>
          <span className={styles.fileSize}>{formatFileSize(size)}</span>
        </div>
      </div>

      <button className={styles.deleteButton} onClick={onDelete}>
        <span className={styles.icon}>
          <TrashIcon fill={"#dc2626"} />
        </span>
      </button>
    </div>
  );
}

// export default function FileCard({ name, size, date, handleDelete }) {
//   const getFileIcon = (name) => {
//     if (!name) return <FileIcon />;

//     const ext = name.split(".").pop().toLowerCase();
//     switch (ext) {
//       case "pdf":
//         return <FilePdfIcon width={27} height={37} fill={"#575757"} />;
//       case "md":
//       case "txt":
//         return <FileTxtIcon width={27} height={37} fill={"#575757"} />;
//       case "csv":
//         return <FileCsvIcon width={27} height={37} fill={"#575757"} />;
//       case "xls":
//       case "xlsx":
//         return <FileSpreadsheetIcon width={27} height={37} fill={"#575757"} />;
//       case "html":
//         return <FileCodeIcon width={27} height={37} fill={"#575757"} />;
//       case "docx":
//       case "doc":
//         return <FileWordIcon />;
//       case "ppt":
//       case "pptx":
//         return <FilePresentationIcon width={27} height={37} fill={"#575757"} />;
//       case "json":
//         return <GoogleDriveIcon size={27} fill="black" />;
//       default:
//         return <FileIcon />;
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.iconWrapper}>{getFileIcon(name)}</div>
//       <div className={styles.data}>
//         <div className={styles.name} title={name}>
//           {name || 'Без имени'}
//         </div>
//         <div className={styles.info}>
//           <div className={styles.infoContainer}>
//             <span className={styles.size}>{size}</span>
//             <span className={styles.date}>{date}</span>
//           </div>
//           <div className={styles.icon} onClick={handleDelete}>
//             <TrashIcon />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
